import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.query-builder.query-block.utils`, {
  'query-builder.dg-user': `User`,
  'query-builder.dg-user_other': `Users`,
  'query-builder.items.duration.name': `Duration`,
  'query-builder.properties-menu.in-cohort': `In Cohort`,
  'query-builder.row-updated': `"{{name}}" has been updated`,
  'query-builder.undo-description-failed': `Unable to undo the description`,
  'query-builder.update-description-failed': `Failed to update the description`,
});
